import { gql } from "@apollo/client";
import { verification } from "./fragments";

export const VERIFICATION_DATA_QUERY = gql`
  query verificationData($documentId: Int!) {
    verificationData(documentId: $documentId) {
      documentId
      verifications {
        ...verification
      }
    }
  }
  ${verification}
`;
